function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["className", "disabled", "divProps", "editable", "readOnly", "required", "textareaProps"];
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * https://w3c.github.io/aria-practices/#combobox
 *
 * https://w3c.github.io/aria-practices/examples/combobox/combobox-select-only.html
 *
 * https://w3c.github.io/aria-practices/examples/combobox/combobox-autocomplete-both.html
 *
 * https://w3c.github.io/aria-practices/examples/combobox/combobox-autocomplete-list.html
 *
 * https://w3c.github.io/aria-practices/examples/combobox/combobox-autocomplete-none.html
 *
 * @param props BaseComboboxProps
 * @returns FunctionComponent<BaseComboboxProps>
 */
var BaseCombobox = function BaseCombobox(props) {
  var className = props.className,
    disabled = props.disabled,
    divProps = props.divProps,
    editable = props.editable,
    readOnly = props.readOnly,
    required = props.required,
    textareaProps = props.textareaProps,
    otherProps = _objectWithoutProperties(props, _excluded);
  return editable ? /*#__PURE__*/React.createElement("textarea", _extends({}, textareaProps, otherProps, {
    "aria-disabled": disabled,
    "aria-haspopup": "listbox",
    "aria-readonly": readOnly,
    "aria-required": required,
    autoCapitalize: "off",
    autoComplete: "off",
    autoCorrect: "off",
    className: classnames(_defineProperty({
      'bf-combobox': true,
      'bf-combobox__input': true
    }, "".concat(className), !!className)),
    disabled: disabled,
    readOnly: readOnly,
    required: required,
    // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
    role: "combobox",
    rows: 1,
    spellCheck: false
  })) : /*#__PURE__*/React.createElement("div", _extends({}, divProps, otherProps, {
    "aria-disabled": disabled,
    "aria-readonly": readOnly,
    "aria-required": required,
    "aria-haspopup": "listbox",
    className: classnames(_defineProperty({
      'bf-combobox': true,
      'bf-combobox__div': true
    }, "".concat(className), !!className)),
    // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
    role: "combobox",
    tabIndex: 0
  }));
};
export { BaseCombobox };